import { devToolsExtension } from "@client/lib/misc";
import { type AppState, type BaseAppState, type GetMiddlewaresArgs } from "@client/types";
import { getMiddlewares as getViewerMiddlewares } from "@client/viewer/store";
import { applyMiddleware, compose, createStore, type Store } from "redux";
import { thunk } from "redux-thunk";
import api from "./lib/api";
import eventMiddleware from "./middleware/event";
import initMiddleware from "./middleware/init";
import menuMiddleware from "./middleware/menu";
import metaMiddleware from "./middleware/meta";
import popupMiddleware from "./middleware/popup";
import { createReducer } from "./reducers";

export const getMiddlewares = (args: GetMiddlewaresArgs<BaseAppState>) => [
  ...getViewerMiddlewares(args),
  initMiddleware,
  eventMiddleware,
  menuMiddleware
];

export default (initialState: Partial<AppState>): Store<AppState> => {
  const args: GetMiddlewaresArgs<BaseAppState> = {
    getStore: () => store,
    createReducer,
    fetchPage: api.loadPage
  };

  const finalCreateStore = compose(
    applyMiddleware(thunk, ...[...getMiddlewares(args), metaMiddleware, popupMiddleware]),
    devToolsExtension
  )(createStore);

  const store = finalCreateStore(createReducer(), initialState) as any;

  if (module && module["hot"]) {
    module["hot"].accept("./reducers", () => {
      const createNextReducer = require("./reducers").default;
      store.replaceReducer(createNextReducer(store.dynamicReducers));
    });
  }

  return store;
};
